import * as React from 'react';
import { MenuItem } from '@chakra-ui/react';
import { useEditorContext } from 'ui-components/RichTextEditor/tiptap/editor_context';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faArrowDown } from '@fortawesome/pro-regular-svg-icons';
import { useLocalization } from '~/framework';

export const AddRowAfterMenuItem = () => {
   const { _js } = useLocalization();
   const { editor } = useEditorContext();

   return (
      <MenuItem
         onClick={() => editor.chain().focus().addRowAfter().run()}
         icon={<FontAwesomeIcon icon={faArrowDown} size="lg" />}
         title={_js('Add row below')}
         isDisabled={!editor.can().addRowAfter()}
         iconSpacing={0}
      />
   );
};
